const config = {
  basename: "/",
  defaultPath: "",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,

  backend_Url: process.env.REACT_APP_BACKEND_URL,

  msal: {
    clientId: process.env.REACT_APP_CLIENT_ID,

    authority: process.env.REACT_APP_AUTHORITY,

     redirectUri: process.env.REACT_APP_REDIRECT_URI,

    postLogoutRedirectUri:
      process.env.REACT_APP_POST_LOGOUT_URI,
  },
};

export default config;